import nurseBedsideTablet from "../../../image/health/aimma-nurse/nurse-bedside-tablet.png";
import { HealthLang } from "../healthTypes";

const PREVIEW_LABEL = {
    En: "Aimma Bedside tablet interface preview",
    Zh: "Aimma 床邊助手平板介面預覽",
    Jp: "Aimma ベッドサイドタブレット画面",
} as const;

/** Fixed display size (17rem × 1.2) — does not scale with viewport; see DECISION_LOG 2026-06 */
const tabletFrameClass =
    "relative w-[20.4rem] shrink-0 overflow-hidden rounded-xl border-[2.5px] border-grey-900 bg-grey-900 shadow-[0_14px_32px_rgba(217,119,6,0.16)] aspect-[1024/703]";

interface NurseBedsideTabletPreviewProps {
    lang: HealthLang;
}

export function NurseBedsideTabletPreview({ lang }: NurseBedsideTabletPreviewProps) {
    const alt = PREVIEW_LABEL[lang] ?? PREVIEW_LABEL.En;

    return (
        <div
            className="relative w-[20.4rem] shrink-0 text-left [text-align:left]"
            role="img"
            aria-label={alt}
        >
            <div className={tabletFrameClass}>
                <img
                    src={nurseBedsideTablet}
                    alt=""
                    aria-hidden="true"
                    className="h-full w-full object-cover object-left-top"
                    loading="lazy"
                    decoding="async"
                />
            </div>
        </div>
    );
}
